import Termly from 'termly-namespace'

import EventAPI from 'utils/event-api'

import consentAllForScanner from './consentAllForScanner'
import CookieConsents from './cookieConsents'
import makeConsentAll from './makeConsentAll'


export function initializeGlobals() {
  if ( window.TERMLY_RESOURCE_BLOCKER_LOADED ) {
    // We're throwing errors in this case because really gross things
    // happen when resource-blocker is double-installed--the banner
    // appears to work just fine, but it quickly goes catatonic and
    // unresponsive. When I changed this to a console.error(),
    // complaints started pouring in that RB was broken. This just
    // goes to show you that people foolishly do web development
    // without their JS console open.
    throw new Error('Termly resource blocker has already been loaded on this page. ' +
                    `Check your markup for duplicate <script> tags including ${ document.currentScript.src }`)
  }

  window.TERMLY_RESOURCE_BLOCKER_LOADED = true

  if ( !window.Termly ) {
    window.Termly = {}
  }

  window.Termly.getConsentState = () => {
    return CookieConsents.getConsentSettings() || Termly.getDefaultConsents()
  }

  window.Termly.on = EventAPI.on
  window.Termly.off = EventAPI.off
}

export function makeTermlyConsentAll({ cookiePolicyVersion }) {
  // Used by termly/cookie_scanner. Deprecated. Use window.Termly.consentAll() instead.
  window.termlyUnblockingCookies = () => consentAllForScanner()

  window.Termly.consentAll = makeConsentAll({
    cookiePolicyVersion,
  })
}
